import { createContext, useContext } from 'react';

import type { CreateRelayEnvironmentOptions } from './types';

const RelayAuthContext = createContext<CreateRelayEnvironmentOptions>({
  acquireToken: () => Promise.resolve('token'),
  host: '',
  isFeatureEnabled: () => false,
});
const Provider = RelayAuthContext.Provider;

type UseRelayAuthContext = () => CreateRelayEnvironmentOptions;
export const useRelayAuthContext: UseRelayAuthContext = () => useContext(RelayAuthContext);

export { Provider as RelayAuthContextProvider };
